import { CatalogGridBannerAsync } from './catalog-grid-banner/catalog-grid-banner.async'
import clsx from 'clsx'
import { FC, Fragment, ReactNode, useMemo } from 'react'

import { ProductCard } from '@/widgets/ProductCard'

import { useMediaQueries } from '@/shared/lib/hooks/useMediaQueries'
import { OrderType, TProduct } from '@/shared/types/product-types'

import { EmptyCatalog } from '../catalog-empty/catalog-empty'

import { CatalogGridLoader } from './catalog-grid-loader/catalog-grid-loader'
import { useIsSingleColumn } from './use-is-single-column'

import cl from './catalog-grid.module.scss'

export type CatalogGridProps = {
	items: TProduct[]
	bannerItem?: ReactNode
	hideMoreButton?: boolean
	isLoading?: boolean
	onReset?: () => void
}

const isProductShow = (title: string, price: number, ordeType: OrderType) =>
	title && (price || ordeType === OrderType.Prereservation || ordeType === OrderType.Archive)

export const CatalogGrid: FC<CatalogGridProps> = ({ items, isLoading, bannerItem, onReset }) => {
	const filteredItems = useMemo(
		() => items?.filter(({ TITLE, PRICE, ORDER_TYPE }) => isProductShow(TITLE, PRICE.VALUE, ORDER_TYPE)) || [],
		[items]
	)
	const { isMobile } = useMediaQueries()
	const isSingleColumn = useIsSingleColumn()

	// Genuine first load (no data yet) → full skeleton. During a refetch that
	// already has items we keep the current grid visible (dimmed) instead of
	// unmounting it, so filter clicks don't flash the whole listing to skeletons.
	if (isLoading && !filteredItems.length) {
		return <CatalogGridLoader isMobile={isMobile} />
	}

	if (!filteredItems.length && !isLoading) {
		return (
			<section className={cl.section} id="catalog-listing">
				<EmptyCatalog onReset={onReset} />
			</section>
		)
	}

	return (
		<section className={cl.section} id="catalog-listing">
			<div className={clsx(cl.inner, isLoading && cl.inner_loading)} aria-busy={isLoading}>
				{filteredItems.map((item, index) => (
					<Fragment key={item.KOD}>
						{bannerItem && (
							<CatalogGridBannerAsync currentIndex={index} className={cl.banner}>
								{bannerItem}
							</CatalogGridBannerAsync>
						)}
						<div className={clsx(cl.item)}>
							<ProductCard key={item.KOD} data={item} type="wideOnMobile" isRatingMobileCompact={!isSingleColumn} />
						</div>
					</Fragment>
				))}
			</div>
		</section>
	)
}
